import { useEffect, useState } from 'react';
import { formatCountdown } from '../lib/format.ts';

/** Live h:mm:ss countdown to `to` (epoch ms). Calls onDone once when it hits zero. */
export function Countdown({ to, onDone }: { to: number; onDone?: () => void }) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);
  const left = to - now;
  useEffect(() => {
    if (left <= 0) onDone?.();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [left <= 0]);
  return <span className="countdown">{formatCountdown(left)}</span>;
}
